module.exports = __webpack_public_path__ + "ae.no1.90f1c76d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/ae.no1.jpg
// module id = OxM5
// module chunks = 0